import { IRepresentedBy, IRepresentedByRes } from './../models';
import axios, { AxiosResponse } from 'axios';

import { authFetch } from './fetch';

const baseUrl = '/api/Admin/RepresentedBy';

export const IRepresentedByAPI = {
  async getAll(filters?: {
    page?: number;
    perPage?: number;
    sortBy?: string;
    sortDirection?: string;
  }): Promise<IRepresentedByRes> {
    try {
        console.log('getAll', baseUrl, filters)
        const response: AxiosResponse<IRepresentedByRes> = await authFetch.get(baseUrl, filters);

        if (!(response.status >= 200 && response.status < 300)) {
            throw Error(response.statusText);
        }

        return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

  async upsert(upsertData: IRepresentedBy): Promise<IRepresentedBy> {
    try {
      const payload = { representedBy: upsertData };
      console.log('upsert', baseUrl, payload)
      const response: AxiosResponse<IRepresentedBy> = await authFetch.put(baseUrl, payload);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data);
      }
      throw error;
    }
  },

    async delete(representedById: number): Promise<void> {

    try {
      
      const response = await authFetch.delete(`${baseUrl}/${representedById}`);

      if (!(response.status >= 200 && response.status < 300)) {
        throw Error(response.statusText);
      }

        return;

    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw Error(error?.response?.data?.Detail);
      }
      throw error;
      }

  },
};
